// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import LabeledCurrency from '../../../../shared/components/labeled-currency';

const PartsValue = props =>
    <section className='parts-value'>
        <LabeledCurrency
            className='claim-value-header'
            data={props.partsTotal}
            label='PARTS'
        />
        <LabeledCurrency
            data={props.partValues}
            label='VALUE'
        />
        <LabeledCurrency
            data={props.onShelfCost}
            label='ON_SHELF_COST'
        />
        <LabeledCurrency
            data={props.partAdditive}
            label='ADDITIVE'
        />
        <LabeledCurrency
            data={props.coreValues}
            label='CORE'
        />
    </section>;

PartsValue.displayName = 'PartsValue';
PartsValue.propTypes = {
    coreValues: PropTypes.number,
    onShelfCost: PropTypes.number,
    partAdditive: PropTypes.number,
    partValues: PropTypes.number,
    partsTotal: PropTypes.number
};

export default PartsValue;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-value/parts-value.js